import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	viewsSpotlightTitle: {
		id: 'portfolio-3-onboarding.changeboarding.views-spotlight-title',
		defaultMessage: 'Views you can use',
		description: 'Title for Views spotlight card',
	},
	viewsSpotlightMessage: {
		id: 'portfolio-3-onboarding.changeboarding.views-spotlight-message',
		defaultMessage:
			'The different aspects of your plan are now easier to find in a simple, more Jira-like menu.',
		description: 'The message for Views spotlight card.',
	},
	viewsSpotlightNext: {
		id: 'portfolio-3-onboarding.changeboarding.views-spotlight-next',
		defaultMessage: 'Next',
		description: 'The Next button label for Views spotlight card.',
	},
	modalHeading: {
		id: 'portfolio-3-onboarding.changeboarding.modal-heading',
		defaultMessage: "It's beginning to look a lot like Jira!",
		description: 'The changeboarding modal title',
	},
	modalContentParagraph1: {
		id: 'portfolio-3-onboarding.changeboarding.modal-content-paragraph-1',
		defaultMessage:
			'Advanced Roadmaps now looks more like the rest of Jira! This new navigation layout allows you to easily discover features, explore other views of your plan, and can be hidden to give you a full width view of your work.',
		description: 'The changeboarding modal first paragraph',
	},
	modalShowMe: {
		id: 'portfolio-3-onboarding.changeboarding.modal-show-me',
		defaultMessage: 'Show me!',
		description: 'The label for the changeboarding modal Show me button',
	},
	modalExploreOnMyOwn: {
		id: 'portfolio-3-onboarding.changeboarding.modal-explore-on-my-own',
		defaultMessage: "I'll explore on my own",
		description: 'The label for the changeboarding modal Explore on my own button',
	},
	flagTitle: {
		id: 'portfolio-3-onboarding.changeboarding.flag-title',
		defaultMessage: 'These are just the highlights',
		description: 'The title for the changeboarding flag.',
	},
	flagContent: {
		id: 'portfolio-3-onboarding.changeboarding.flag-content',
		defaultMessage:
			"We've also redesigned how Scenarios look, how to save a view of your plan, and more. To see all the changes, check out our Community page!",
		description: 'The content for the changeboarding flag',
	},
	flagClose: {
		id: 'portfolio-3-onboarding.changeboarding.flag-close',
		defaultMessage: 'Close',
		description: 'The label for the changeboarding flag Close button',
	},
	flagReadCommunityPost: {
		id: 'portfolio-3-onboarding.changeboarding.flag-read-community-post',
		defaultMessage: 'Read community post',
		description: 'The label for the changeboarding flag "Read community post" button',
	},
});
